export const DESKTOP_WIDTH = 1024;

export default function isMobile(width = window.innerWidth) {
  return width < DESKTOP_WIDTH;
}
